import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LoginAPI } from "../../api/login";
import { useAuth } from "../../context/AuthContext";
import Sidebar from "../navbar/SideBar";
import { Button } from "@mui/material";
import MobileSidebarIcon from "../../assets/SVGs/Sidebar/MobileSidebarIcon";

const AppLayout = ({ children }) => {
  const { logout, user } = useAuth();
  const navigate = useNavigate();

  const [isOpen, setIsOpen] = useState(false);

  const Logout = async () => {
    try {
      const { content } = await LoginAPI.logout();
      if (content === "OK") {
        logout?.();
        navigate("/login");
      }
    } catch (e) {
      console.error(e);
    }
  };

  const greeting =
    user?.role === "ADMIN"
      ? "Hello, Admin"
      : user
        ? `Hello, ${user.first_name} ${user.last_name}`
        : "";

  return (
    <div className="root">
      <Sidebar />
      <div className="mainContent">
        <div className="header">
          <div className="flex align-center gap-16">
            <MobileSidebarIcon
              className="mobile-sidebar-icon"
              onClick={() => setIsOpen(true)}
            />
            {greeting && <span className="header-greeting">{greeting}</span>}
          </div>
          <Button onClick={Logout} className="header-btn">
            Log Out
          </Button>
        </div>
        {children}

        <Sidebar
          className="mobile-sidebar"
          isOpen={isOpen}
          setIsOpen={setIsOpen}
        />
      </div>
    </div>
  );
};

export default AppLayout;
